import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form-mui';
import { TagsInput } from './TagsInput';

export interface TagsFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  name: TName;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  fullWidth?: boolean;
}

export function TagsField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  label,
  placeholder,
  disabled,
  required,
  fullWidth,
}: TagsFieldProps<TFieldValues, TName>) {
  const { control } = useFormContext<TFieldValues>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TagsInput
          value={field.value || []}
          onChange={(tags) => field.onChange(tags)}
          label={label}
          placeholder={placeholder}
          disabled={disabled}
          error={!!fieldState.error?.message}
          helperText={fieldState.error?.message}
          required={required}
          fullWidth={fullWidth}
        />
      )}
    />
  );
}
